"use client";

import Link from "next/link";
import { Crown } from "lucide-react";
import { useEffectivePass } from "@/hooks/useEffectivePass";
import RandomProblems from "@/components/RandomProblems";
import { Skeleton } from "@/components/ui/skeleton";

// 프리미엄 모의고사 출제 분포 (JCG-1431 → JCG-2366에서 26년 1회 실기 기출 분포로 갱신)
// 26년 1회 실기 실제 과목별 출제 수를 반영(2회 예상 범위 기준):
// C 2 · Java 2 · Python 3 · DB 1 · SQL 3 · 네트워크/OS 2 · SW 개발 1 · SW 설계 3 · 보안/신기술 3 = 20문제
// scope 값은 premium 모드에서 subject(과목 파일명)로 매칭됨(random-problems route). SQL은 problems_sql.yaml(subject="sql")에서 출제.
const MOCK_EXAM_SCOPES = [
  { scope: "c", count: 2 },
  { scope: "java", count: 2 },
  { scope: "python", count: 3 },
  { scope: "db", count: 1 },
  { scope: "sql", count: 3 },
  { scope: "network-os", count: 2 },
  { scope: "sw-dev", count: 1 },
  { scope: "sw-design", count: 3 },
  { scope: "security-newtech", count: 3 },
];

export default function MockExamClient() {
  const { isLoaded, isPremiumOrAbove } = useEffectivePass();

  // Clerk 로드 전: 스켈레톤
  if (!isLoaded) {
    return (
      <div className="my-10 space-y-4">
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className="space-y-3">
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
          </div>
        ))}
      </div>
    );
  }

  // 비프리미엄: 프리미엄 이상 플랜 안내 카드 (멤버십 CTA)
  if (!isPremiumOrAbove) {
    return (
      <div className="my-10 overflow-hidden rounded-xl border-2 border-orange-200 bg-orange-50 dark:border-orange-800 dark:bg-orange-900/20">
        <div className="p-6 sm:p-8 text-center">
          <div className="flex justify-center mb-4">
            <Crown className="w-12 h-12 text-orange-500" />
          </div>
          <h2 className="text-lg sm:text-xl font-bold text-gray-900 dark:text-white">
            프리미엄 이상 플랜이 필요해요
          </h2>
          <p className="mt-3 text-sm sm:text-base text-gray-600 dark:text-gray-300">
            프리미엄 모의고사는 프리미엄 이상 플랜에서 풀 수 있어요.
            <br />
            총 20문제가 매번 랜덤으로 출제되는 실전 모의고사를 무제한으로 풀어보세요.
          </p>
          <Link
            href="/membership"
            className="mt-6 inline-flex items-center justify-center gap-2 px-6 py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors"
          >
            <Crown className="w-5 h-5" />
            프리미엄 플랜 보러가기
          </Link>
        </div>
      </div>
    );
  }

  // 프리미엄 이상: 모의고사 렌더
  return (
    <RandomProblems
      premium
      scopes={MOCK_EXAM_SCOPES}
      scoreTitle="프리미엄 모의고사"
    />
  );
}
